import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	stroke: "#595959",
	strokeWidth: 1.5,
	strokeLinejoin: "round",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 5.251C7.969 5.183 3.8 8 1.179 10.885c-.57.633-.57 1.593 0 2.226C3.743 15.935 7.9 18.817 12 18.748c4.1.069 8.258-2.813 10.824-5.637.57-.633.57-1.593 0-2.226C20.2 8 16.031 5.183 12 5.251z" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.75 12a3.75 3.75 0 1 1-7.5-.001 3.75 3.75 0 0 1 6.402-2.651A3.75 3.75 0 0 1 15.75 12h0z" })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22none%22%20stroke%3D%22%23595959%22%20stroke-width%3D%221.5%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22M12%205.251C7.969%205.183%203.8%208%201.179%2010.885c-.57.633-.57%201.593%200%202.226C3.743%2015.935%207.9%2018.817%2012%2018.748c4.1.069%208.258-2.813%2010.824-5.637.57-.633.57-1.593%200-2.226C20.2%208%2016.031%205.183%2012%205.251z%22%2F%3E%3Cpath%20d%3D%22M15.75%2012a3.75%203.75%200%201%201-7.5-.001%203.75%203.75%200%200%201%206.402-2.651A3.75%203.75%200%200%201%2015.75%2012h0z%22%2F%3E%3C%2Fsvg%3E";
